/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  rootpath: 'https://app.turismo.laplata.gob.ar/api/',
  basicAuth: 'YWRtaW46MTM1Nw==',
  userImgPath: '/img/user/',
  POIImgPath: '/img/point-of-interest/',
  entityImgPath: '/img/entity/',
  audioGuideImgPath: '/img/audio-guide/',
  audioGuidePath: '/file/audio-guide/',
  audioGuidePath_en_EN: '/file/audio-guide_en_EN/',
  audioGuidePath_pt_PT: '/file/audio-guide_pt_PT/',
  eventImgPath: '/img/event/',
  turistCircuitImgPath: '/img/turist-circuit/',
  reCaptchaSiteKey: '6LesPwodAAAAAHF3Ml2C8Q4c3q2itSivOKOFoHEZ',
  noImgPath: '/assets/images/imagesNoDispo.png',
  weatherImgPath: '/img/weather/',
};
